export const HullType = {
    MONOHULL:'MONOHULL',
    MULTIHULL: 'MULTIHULL'
}
